import { FormationDetailProps } from '@/types/formation';

export const macSstFormation: FormationDetailProps = {
  id: "3",
  title: "Formation MAC SST (Maintien et Actualisation des Compétences SST)",
  description: "Formation de recyclage obligatoire tous les 24 mois permettant de maintenir et actualiser ses compétences de Sauveteur Secouriste du Travail.",
  duration: "7 heures (1 jour)",
  category: "Secourisme",
  imageSrc: "/images/formations/sst2.webp",
  slug: "mac-sst",
  reference: "F-MAC SST",
  price: "Sur devis – nous contacter",
  targetAudience: "Sauveteur Secouriste du Travail souhaitant renouveler son certificat SST",
  prerequisites: "Être titulaire du certificat SST en cours de validité",
  objectives: [
    "Maintenir et actualiser les compétences du SST définies dans le référentiel de formation",
    "Intervenir efficacement face à une situation d\'accident du travail",
    "Mettre en application ses compétences au service de la prévention des risques professionnels dans son entreprise",
    "Évaluer les compétences du SST face à toutes situations d\'accident"
  ],
  program: [
    {
      title: "Retour d\'expérience et partage d\'informations",
      items: [
        "Échanges sur les interventions réalisées",
        "Actualisation des connaissances en fonction du retour d\'expérience"
      ]
    },
    {
      title: "Domaine de compétence 1 : Intervenir face à une situation d\'accident du travail",
      items: [
        "Situer son rôle de SST dans l\'organisation des secours dans l\'entreprise",
        "Protéger de façon adaptée",
        "Examiner la victime",
        "Garantir une alerte favorisant l\'arrivée de secours adaptés au plus près de la victime",
        "Secourir la victime de manière appropriée",
        "Révision des gestes d\'urgence"
      ]
    },
    {
      title: "Domaine de compétence 2 : Contribuer à la prévention des risques professionnels dans l'entreprise",
      items: [
        "Situer son rôle de SST dans l'organisation de la prévention de l'entreprise",
        'Caractériser des risques professionnels dans une situation de travail',
        'Participer à la maîtrise des risques professionnels par des actions de prévention'
      ]
    },
    {
      title: 'Évaluation et certification',
      items: [
        'Évaluation continue des compétences tout au long de la formation',
        'Épreuve certificative finale',
        'Renouvellement du certificat de Sauveteur Secouriste du Travail'
      ]
    }
  ],
  pedagogicalMethods: [
    "Exposés interactifs",
    "Démonstrations par le formateur",
    "Études de cas",
    "Mises en situation professionnelle sur des cas concrets",
    "Utilisation de mannequins et défibrillateurs de formation",
    "Formation pratique et apprentissage des gestes"
  ],
  evaluationMethods: [
    "Évaluation continue durant la formation à travers les mises en situation",
    "Évaluation certificative finale selon la grille de certification de l\'INRS",
    "QCM pour évaluation des connaissances théoriques"
  ],
  certification: "Renouvellement du certificat de Sauveteur Secouriste du Travail (valable 24 mois) pour les candidats qui ont participé à l\'ensemble de la formation et satisfait aux épreuves certificatives.",
  registrationProcess: [
    "Inscription possible jusqu\'à 10 jours avant le début de la formation (sous réserve de places disponibles)",
    "Validation de l\'inscription après réception du bon de commande ou de la convention signée"
  ],
  accessibilityCriteria: "Formation accessible aux personnes en situation de handicap. Nous contacter pour adapter la formation selon les besoins spécifiques.",
  formatterInfo: {
    name: "Sebastien Davrainville - SDPSI Formation",
    phone: "06.22.61.04.09",
    email: "sdpsiformation@orange.fr",
    website: "www.sdpsi-formations.fr"
  }
};
